<script setup lang="ts">
import { i18n } from '../../../localization'
import Alert from '../../base/Alert.vue'
import { ExclamationCircleIcon } from '@heroicons/vue/solid'
import {
    showNoFinancialSituationProvidedOrInvestmentIsTooHighWarning,
    showNotEnoughExperienceWarning,
    showNotEnoughRiskAcknowledgementsWarning,
} from '../../../utilities/account/useEcspRegulatory'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { storeToRefs } from 'pinia'

const { acceptAllWarnings } = storeToRefs(useInvestmentProcessDataState())
</script>

<template>
    <div class="space-y-4 pb-2">
        <Alert
            v-if="showNotEnoughExperienceWarning()"
            class="!items-start !border-none !shadow-none"
            :title-text="i18n.global.t('investment_process.ecsp.not_enough_experience_title')"
            :description-text="i18n.global.t('investment_process.ecsp.not_enough_experience_description')">
            <template #icon>
                <ExclamationCircleIcon class="h-6 w-6 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
            </template>
        </Alert>
        <Alert
            v-if="showNotEnoughRiskAcknowledgementsWarning()"
            class="!items-start !border-none !shadow-none"
            :title-text="i18n.global.t('investment_process.ecsp.not_enough_risk_acknowledgements_title')"
            :description-text="i18n.global.t('investment_process.ecsp.not_enough_risk_acknowledgements_description')">
            <template #icon>
                <ExclamationCircleIcon class="h-6 w-6 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
            </template>
        </Alert>
        <Alert
            v-if="showNoFinancialSituationProvidedOrInvestmentIsTooHighWarning()"
            class="!items-start !border-none !shadow-none"
            :title-text="i18n.global.t('investment_process.ecsp.investment_too_high_title')"
            :description-text="i18n.global.t('investment_process.ecsp.investment_too_high_description')">
            <template #icon>
                <ExclamationCircleIcon class="h-6 w-6 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
            </template>
        </Alert>

        <div class="relative flex items-start space-x-5 px-5">
            <div class="flex h-6 items-center">
                <input
                    id="understand_and_accept_all_warnings"
                    v-model="acceptAllWarnings"
                    name="understand_and_accept_all_warnings"
                    type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
            </div>
            <div class="ml-3 text-sm leading-6">
                <label for="understand_and_accept_all_warnings" class="font-semibold text-gray-900">{{
                    $t('investment_process.accept_all_warnings')
                }}</label>
            </div>
        </div>
    </div>
</template>
